angular.module('elfium').service('reportService', ['$q', 'elfiumRestService', 'reportDtoService', 'reportPhasesByTaskTypeFilter', 'elfiumConvertFieldTypesFilter', 'REPORT_FIELD_TYPES', 'TASK_TYPES', 'REPORT_REALIZATION',
    function ($q, elfiumRestService, reportDtoService, reportPhasesByTaskTypeFilter, elfiumConvertFieldTypesFilter, REPORT_FIELD_TYPES, TASK_TYPES, REPORT_REALIZATION) {
        var that = this;
        that.getReportsByBusinessCaseId = function (businessCaseId) {
            var searchParameters = {
                obchodniPripadId: businessCaseId
            };
            return that.searchReports(searchParameters).then(function (reports) {
                return reportDtoService.buildReportsDto(reports);
            });
        };
        that.searchReports = function (searchParameters) {
            return elfiumRestService.searchReports(searchParameters).then(that._convertFieldTypes);
        };
        that.updateReports = function (businessCaseId, reportsDto, reportsUnchangedDto) {
            if (!businessCaseId) {
                throw 'no businessCaseId';
            }
            var reports = reportDtoService.buildReportsFromDto(businessCaseId, reportsDto);
            var reportsUnchanged = reportDtoService.buildReportsFromDto(businessCaseId, reportsUnchangedDto);
            var reportsSplitByAction = that._splitReportsByAction(reports, reportsUnchanged);
            return $q.all([
                that._updateReports(reportsSplitByAction.update),
                that._createReports(reportsSplitByAction.create),
                that._deleteReportsByIds(reportsSplitByAction.deleteIds)
            ]);
        };
        that._splitReportsByAction = function (reports, reportsUnchanged) {
            var result = {
                update: [],
                create: [],
                deleteIds: []
            };
            angular.forEach(reportsUnchanged, function (reportUnchanged) {
                result.deleteIds.push(reportUnchanged.id);
            });
            angular.forEach(reports, function (report) {
                if (report.id) {
                    result.update.push(report);
                    var deleteIdsIndex = result.deleteIds.indexOf(report.id);
                    if (deleteIdsIndex != -1) {
                        result.deleteIds.splice(deleteIdsIndex, 1);
                    } else {
                        throw "existing report with id should be also in reportUnchanged in reportService/_splitReportsByAction";
                    }
                } else {
                    result.create.push(report);
                }
            });
            return result;
        };
        that._updateReports = function (reportsToUpdate) {
            var updatePromises = [];
            angular.forEach(reportsToUpdate, function (reportToUpdate) {
                updatePromises.push(elfiumRestService.updateReport(reportToUpdate));
            });
            return $q.all(updatePromises);
        };
        that._deleteReportsByIds = function (reportIdsToDelete) {
            var deletePromises = [];
            angular.forEach(reportIdsToDelete, function (reportId) {
                deletePromises.push(elfiumRestService.deleteReport(reportId));
            });
            return $q.all(deletePromises);
        };
        that._createReports = function (reportsToCreate) {
            var createPromises = [];
            angular.forEach(reportsToCreate, function (reportToCreate) {
                createPromises.push(elfiumRestService.createReport(reportToCreate));
            });
            return $q.all(createPromises);
        };
        that._convertFieldTypes = function (reports) {
            return $q.when(elfiumConvertFieldTypesFilter(REPORT_FIELD_TYPES, reports));
        };
        that.buildInitialReport = function () {
            var report = {};
            angular.forEach(TASK_TYPES, function (taskType) {
                var reportPhases = reportPhasesByTaskTypeFilter(taskType);
                report[taskType] = {};
                for (var i = 0; i < reportPhases.length; ++i) {
                    report[taskType][reportPhases[i]] = {};
                    report[taskType][reportPhases[i]][REPORT_REALIZATION.PLAN] = [reportDtoService.buildReportDto({})];
                    report[taskType][reportPhases[i]][REPORT_REALIZATION.ACTUAL] = [reportDtoService.buildReportDto({})];   
                }               
            });
            return report;
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/report/reportService.ts